var _rect, _path, _path2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeradigm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "Veradigm (Allscripts)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22 L28 42 L38 22",
    fill: "none",
    stroke: "#1e5a9a",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32 L28 38 L30 32",
    fill: "none",
    stroke: "#e76f00",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 30,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1e5a9a"
  }, "VERADIGM")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 46,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 500,
    fill: "#64748b",
    letterSpacing: 1
  }, "FKA ALLSCRIPTS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeradigm);
export default __webpack_public_path__ + "static/media/veradigm.ec8975727fc39c658b68a28a7ffe9820.svg";
export { ForwardRef as ReactComponent };